module.exports = __webpack_public_path__ + "img/logo.786dd5f5.png";